export default __webpack_public_path__ + "static/media/Rachel_Payne_AHV_In_Moms_We_Trust.b0913631.jpg";